import React from 'react';

type SchemaProps = {
    input: { [index: string]: any };
};

export function Schema(props: SchemaProps) {
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(props.input) }} />;
}
